<template>
<div class="tqmask" @click="closewrap">
  <div class="tqwrap" @click.stop="tqrf">
    <div class="tqtitle oneline">{{team.project_name}}</div>
    <div class="tqdesc">
      {{team.spec_name}}
      <text class="tqclr">{{team.color_china}}</text>
    </div>
    <div v-if="team.extra_information.length>0">
      <div class="tqwsxi">完善信息</div>
      <div class="tqiptlist" v-for="(item, index) in team.extra_information" :key="index">
        <input v-if="!modifyBol" class="tqipt" @input="bmteam($event, index)" @blur="upkeyboard" :placeholder="'输入'+item" />
        <input v-if="modifyBol" :name="item" @input="setvalue($event, index)" :value="team.information[item]" @blur="upkeyboard" class="tqipt" :placeholder="'输入'+item" />
      </div>
    </div>
    <button v-if="!modifyBol"
            @click="gophoto"
            class="tqphoto"
            :class="[noops && team.extra_information.length > 0 ? 'tqnobtn' : '']">去拍摄</button>
    <button v-if="modifyBol" @click="modifyinfo" form-type="submit" class="tqphoto">确定</button>
    <div class="tqtime">截止日期：{{team.end_time}}</div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { upkeyboard } from '@/utils/utils'
export default {
  name: 'teamquestion',
  props: {
    team: {
      type: Object,
      default: () => {}
    },
    noops: {
      type: Boolean,
      default: true
    },
    modifyBol: {
      type: Boolean,
      default: false // 修改信息用的值
    }
  },
  methods: {
    closewrap () {
      this.$emit('onCloseWrap')
    },
    tqrf () {
      return false
    },
    gophoto () {
      const { noops, team } = this
      const { extra_information, information } = team
      if (extra_information.length === 0 || !noops) {
        this.$emit('onGoPhoto')
      }
    },
    modifyinfo () {
      const obj = {}
      const { team } = this
      this.$emit('onHandleInfo', team.information)
    },
    upkeyboard () {
      upkeyboard()
    },
    setvalue (e, idx) {
      const { team } = this
      const { value } = e.target
      const keyname = team.extra_information[idx]
      team.information[keyname] = value
    },
    bmteam (e, idx) {
      const { team } = this
      const { value } = e.target
      const keyname = team.extra_information[idx]
      const data = {
        keyname,
        value
      }
      this.$emit('onHandleInfo', data)
    }
  },
  computed: {
    ...mapState(['isIos'])
  }
}
</script>

<style scoped>
.tqmask{
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  width:100%;
  height:100%;
  top:0;
  left:0;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}
.tqwrap{
  width:5.6rem;
  max-height: 7.48rem;
  overflow: scroll;
  box-sizing: border-box;
  padding:.48rem .4rem;
  border-radius: .16rem;
  background-color: white;
}
.tqtitle{
  font-size: .32rem;
  color:#303133;
  font-weight: bold;
  margin-bottom: .08rem;
}
.tqdesc{
  font-size: .26rem;
  color:#838485;
}
.tqclr{
  margin-left: 1em;
  padding-left: 1em;
  border-left: 1px solid #838485;
  display: inline-block;
}
.tqphoto{
  background-color: #233CFF;
  color:white;
  border-radius: .12rem;
  height:.8rem;
  line-height: .8rem;
  font-size: .28rem;
  margin-top: .64rem;
  display: block;
  border:none;
  width: 100%;
}
.tqtime{
  font-size: .24rem;
  color:#ADADAE;
  text-align: center;
  margin-top: .16rem;
}
.tqnobtn{
  background-color: #F2F2F2;
  color:#D6D6D7;
}
.tqwsxi{
  font-size: .28rem;
  color:#303133;
  font-weight: bold;
  margin-top: .32rem;
}
.tqiptlist{
  width:100%;
  height:.96rem;
  box-sizing: border-box;
  border-radius: .12rem;
  border:1px solid #E5E5EA;
  margin-top: .16rem;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.tqipt{
  width:100%;
  height: 100%;
  border: none;
  text-indent: 1em;
  font-size: .3rem;
}
</style>
